import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';

interface IPageGs0104 {
    valeursEcran: any;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Gs0104Controller(Menu: IMenuClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageGs0104 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        //bloc: 'use',
        //navigatePage: ???Route.NAME,
        fonctions: {
            rechercheCollapsable: false, //Afficher le champs de recherche en permanence.
            supprime: true,
            nouveau: false,
            boutonDupliquer: false
        },
        pagination: {
            nombreElementPage: 100
        },
        colonnesFixesGauche: [
            { nom: 'usenom', largeur: 160 },
            { nom: 'useprn', largeur: 160 }
        ],
        colonnesVisibles: [
            { nom: 'useadrele', largeur: 200 },
            { nom: 'useadrl01', largeur: 200 },
            { nom: 'useadrl02', largeur: 200 },
            { nom: 'useadrl03', largeur: 200 },
            { nom: 'usevil', largeur: 120 },
            { nom: 'usepay', largeur: 140 },
            { nom: 'usepro', largeur: 100 },
            { nom: 'usecodpos', largeur: 120 },
            //{ nom: 'vacsysreg', largeur: 200 },
            { nom: 'usenumtel', largeur: 120 },
            { nom: 'usenumtelpos', largeur: 160 }
            //{ nom: 'usenumfax', largeur: 120 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('usenom'),
            new FormulaireItem('useprn'),
            new FormulaireItem('useadrele'),
            new FormulaireItem('useadrl01'),
            new FormulaireItem('useadrl02'),
            new FormulaireItem('useadrl03'),
            new FormulaireItem('usevil'),
            new FormulaireItem('muncleint'), // Rendu hidden dans le Backend, car la ville usevil est en saisie libre
            new FormulaireItem('usepay'),    // Rendu hidden dans le Backend, car alimenté via lov de 'pyscleint'
            new FormulaireItem('pyscleint'),
            new FormulaireItem('usepro'),    // Rendu hidden dans le Backend, car alimenté via lov de 'etacleint'
            new FormulaireItem('etacleint'),
            new FormulaireItem('usecodpos'),
            new FormulaireItem('vacsysreg'), // Rendu hidden dans le Backend, car la region est absente du formulaire référence
            new FormulaireItem('usenumtel'),
            new FormulaireItem('usenumtelpos'),
            new FormulaireItem('usenumfax')  // Rendu hidden dans le Backend
        ], { largeurDefaut: 20 })
    };
}
